"use client";

import Link from "next/link";
import { SectionHeader } from "./SectionHeader";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname, withLocale } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";

export function Contact() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).landing;

  return (
    <section id="contact" className="container mx-auto px-4 py-12 md:px-6 mb-20">
      <SectionHeader
        title={content.landingContactTitle}
        description={content.landingContactDescription}
      />

      <div className="mx-auto grid max-w-3xl gap-4 md:grid-cols-2">
        <a
          href="mailto:support@dogufy.com"
          className="rounded-[30px] border-2 border-positivus-dark bg-white p-8 shadow-[0_5px_0_0_#191A23] transition-colors hover:bg-positivus-green"
        >
          <p className="text-sm font-medium uppercase tracking-[0.18em] text-gray-500">
            {content.sayHi}
          </p>
          <h3 className="mt-4 text-2xl font-medium">support@dogufy.com</h3>
          <p className="mt-3 text-sm leading-7 text-gray-600">
            {content.landingContactDescription}
          </p>
        </a>

        <Link
          href={withLocale(locale, "/contact")}
          className="rounded-[30px] border-2 border-positivus-dark bg-positivus-dark p-8 text-white shadow-[0_5px_0_0_#191A23] transition-colors hover:bg-black"
        >
          <p className="text-sm font-medium uppercase tracking-[0.18em] text-positivus-green">
            {content.getQuote}
          </p>
          <h3 className="mt-4 text-2xl font-medium">{content.landingContactTitle}</h3>
          <p className="mt-3 text-sm leading-7 text-white/80">
            Open the contact page for direct support details, repository links, and privacy information.
          </p>
        </Link>
      </div>
    </section>
  );
}
